import axios from 'axios';
import { API_URL } from '../config/api.config';



const getAuthInfo = () => {
    const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id || ''
    const token = localStorage.getItem('token');
    return { garageId, token };
};

const createAuthAxios = () => {
    const { token } = getAuthInfo();
    return axios.create({
        baseURL: API_URL,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};
const authAxios = createAuthAxios()

export const aiAnalysisService = {
    // Récupérer l'analyse IA existante pour une inspection
    async getAnalyses(inspectionId: string) {
        try {
            const response = await authAxios.get(`/inspections/${inspectionId}/inspections/ai-analysis`);
            return response.data;
        } catch (error) {
            console.error('Error fetching AI analyses:', error);
            throw error;
        }
    },

    // Générer une nouvelle analyse IA
    async generateAnalysis(inspectionId: string, garageId: string) {
        try {
            const response = await authAxios.post(`/inspections/${inspectionId}/ai-analysis`, { garageId });
            console.log("Analystysis result",response);
            return response.data;
        } catch (error) {
            console.error('Error generating AI analysis:', error);
            throw error;
        }
    },

    // Régénérer l'analyse IA
    async regenerateAnalysis(inspectionId: string, analysisId: string) {
        try {
            const response = await authAxios.post(`/inspections/${inspectionId}/ai-analysis/${analysisId}/regenerate`);
            return response.data;
        } catch (error) {
            console.error('Error regenerating AI analysis:', error);
            throw error;
        }
    },

    // Mettre à jour l'analyse IA manuellement
    async updateAnalysis(inspectionId: string, analysisId: string, updateData: any) {
        try {
            const response = await authAxios.put(`/inspections/${inspectionId}/ai-analysis/${analysisId}`, updateData);
            return response.data;
        } catch (error) {
            console.error('Error updating AI analysis:', error);
            throw error;
        }
    }
};